import breakpoints from 'theme/breakpoints';

export default function uponMediaSize(bpType: 'xs' | 'sm' | 'md' | 'lg' | 'xl') {
  const mediaValue = [breakpoints.values].map((bp) => `@media (min-width: ${bp[bpType]}px)`);
  return mediaValue[0];
}
